import { useForm } from 'react-hook-form';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { useRiskRegisterStore } from 'store/riskRegister.store';

import { FormProps } from 'components/widgets/RiskRegister/components/RunQsra/components/RunQsraForm/RunQsraForm';

export const useRunQsraFormLogic = ({ api, riskIds, latestVersionId }) => {
    const { handleSnackBar } = useCustomSnackBar();
    const { update, isRunningQsra, period } = useRiskRegisterStore();

    const form = useForm<FormProps>({
        values: {
            numOfSimulations: 1000,
            riskIds: riskIds,
            metaDataId: latestVersionId,
            taskVersionHashCode: null,
            taskVersionLabel: null,
            period: period,
        },
    });

    const handleSaveUseForm = (data: FormProps) => {
        api.runQsraAnalysis.instance.mutate(
            {
                numOfSimulations: data.numOfSimulations,
                riskIds: data.riskIds,
                metaDataId: data.metaDataId,
                taskVersionHashCode: data.taskVersionHashCode,
            },
            {
                onSuccess: (response) => {
                    update({
                        riskIds: data.riskIds,
                        numOfIterations: data.numOfSimulations,
                        taskVersionHashCode: data.taskVersionHashCode,
                        isRunningQsra: true,
                        period: data.period,
                        taskVersionLabel: data.taskVersionLabel,
                        qsraResponseKey: response,
                    });
                    handleSnackBar(`QSRA analysis started`, 'success');
                },
                onError: (error) => DEFAULT_ERROR({ error, handleError: handleSnackBar }),
            },
        );
    };

    return {
        logic: {
            form,
            handleSaveUseForm,
            isRunningQsra,
        },
    };
};
